module.exports = __webpack_public_path__ + "static/media/certified-fr.aca6d6d8.png";